import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RedemptionpointComponent } from './redemptionpoint/redemptionpoint.component';
import { RedemptionPointListComponent } from './redemption-point-list/redemption-point-list.component';


import {NgxSpinnerModule} from "ngx-spinner";
import {SharedModule} from "@shared/shared.module";
import {PopoverModule} from "ngx-bootstrap/popover";
import {FormsModule} from "@angular/forms";
import {QRCodeModule} from "angularx-qrcode";

@NgModule({
  declarations: [
    RedemptionpointComponent,
    RedemptionPointListComponent
  ],
  imports: [
    CommonModule,
    NgxSpinnerModule,
    SharedModule,
    PopoverModule,
    FormsModule,
    QRCodeModule,
  ],
  exports: [
    RedemptionPointListComponent
  ]
})
export class RedemptionPointModule { }
